import { render, staticRenderFns } from "./BaseLeftNavigation.vue?vue&type=template&id=28d9339b&"
import script from "./BaseLeftNavigation.vue?vue&type=script&lang=js&"
export * from "./BaseLeftNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BaseLeftNavigation.vue?vue&type=style&index=0&id=28d9339b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports